<template>
<footer class="sitewide-footer overflow-x-hidden">

    <section class="pre-footer pb-15% pt-10% px-4 relative">

        <div class="max-w-5xl w-full mx-auto relative z-10">
  
            <div class="max-w-md relative z-20">
                <SmoothLoader tag="h3" class="headline text-primary-800 text-4xl ht:text-5xl font-headline leading-tight my-8 vt:my-0" v-if="footer.data.headline" v-html="footer.data.headline"></SmoothLoader>
                <SmoothLoader>
                    <FooterForm v-if="!hideForm" :headline="footer.data.form_headline"></FooterForm>
                </SmoothLoader>
            </div>

            <SmoothLoader class="footer-img relative vt:absolute z-10">
                <img class="" src="/wp-content/themes/landslide/img/footer.png" aria-hidden="true">
                <Title class="title absolute"></Title>
            </SmoothLoader>
                
        </div>

        <div class="backdrop absolute w-full">
            <img src="/wp-content/themes/landslide/img/hero-backdrop.png" aria-hidden="true">
        </div>

    </section>
    
    <section class="footer-bottom px-4 relative pt-20% pb-20% vt:pt-5% vt:pb-10% bg-gray-500">

        <div class="max-w-4xl mx-auto">

            <div class="flex justify-center items-center mb-12">
                <nav class="flex flex-wrap items-center top-menu">
                    <div v-for="link in topMenu" class="mx-4 relative w-full vt:w-auto">
                        <Link class="menu-link accent-link text-center block relative uppercase font-headline font-bold text-gray-800 text-sm tracking-wider" :href="link.href">
                            {{ link.name }}
                        </Link>
                    </div>
                </nav>
            </div>

            <div class="flex justify-center my-12" v-if="footer.data.splatter_button">
                <Button variant="button-splat" :label="footer.data.splatter_button.label" :href="footer.data.splatter_button.href"></Button>
            </div>

            <div class="contact-info text-center max-w-xl mx-auto" v-html="footer.data.contact_info"></div>

            <div class="flex justify-center my-8" v-if="bottomMenu.length">
                <nav class="bottom-menu">
                    <div v-for="link in bottomMenu" class="mx-4 relative">
                        <Link class="menu-link accent-link inline-block relative uppercase font-headline font-bold text-gray-700 text-xs tracking-wider hover:text-secondary-500 focus:text-secondary-500" :href="link.href">
                            {{ link.name }}
                        </Link>
                    </div>
                </nav>
            </div>

            <div class="text-center max-w-xl mx-auto">
                <p class="text-gray-800 text-lg mb-8" v-html="footer.data.copyright"></p>
                <p class="text-gray-900 text-sm" v-html="footer.data.disclaimer"></p>
            </div>
            
        </div>

    </section>
</footer>
</template>

<script>
import Title from './Utilities/Title.vue';
import FooterForm from './Utilities/FooterForm.vue';

export default {

    props: {
        context: {
            required: true
        },
        hideForm: {
            default: false
        }
    },

    setup(props) {
        return {
            hideForm: props.context.content.hide_footer_form,
            topMenu: props.context.nav?.footer_menu || [],
            bottomMenu: props.context.nav?.footer_bottom_menu || [],
            ...props.context,
        }
    },

    components: {
        FooterForm,
        Title
    }

}
</script>
